'use client';

import {
  CaseStudyBody,
  CaseStudyResultsTable,
} from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { CaseStudyQuote } from '@/components/case-study/case-study-quote';
import { CustomerVideos } from '@/components/sections/customer-videos';
import Testimonials from '@/components/sections/testimonials';
import { useTranslation } from '@/lib/i18n/context';

const TrunkrsCaseStudy = () => {
  const { t, isRTL } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="Trunkrs"
        title={
          t.customerStories[
            'How Trunkrs automates 80% of delivery support with 4.8/5 rating'
          ]
        }
        subtitle={
          t.customerStories[
            "Open's AI agent handles 80% of support across email and chat for Trunkrs' delivery operations. Customers get instant tracking updates, delivery changes, and issue resolution."
          ]
        }
        stats={[
          {
            value: isRTL ? '٨٠٪' : '80%',
            label: t.customerStories['Automation rate'],
          },
          {
            value: isRTL ? '٤,٨/٥' : '4.8/5',
            label: t.customerStories['Google rating'],
          },
          {
            value: isRTL ? '+٦٠ ألف' : '60K+',
            label: t.customerStories['Reviews'],
          },
        ]}
        videoSrc="/home/features/trunkrs.mp4"
        videoVariant="ambient"
      />

      <CaseStudyBody
        aside={{
          logoSrc: '/logos/logo-trunkrs.svg',
          logoAlt: 'Trunkrs',
          company: t.customerStories['trunkrs_company_description'],
          industry: t.customerStories['Logistics / Delivery Services'],
          websiteUrl: 'https://www.trunkrs.com',
          extras: [
            {
              label: t.customerStories.Specialization,
              value: t.customerStories['Fresh & Frozen product delivery'],
            },
          ],
          keyResults: [
            t.customerStories['• 80% automation rate'],
            t.customerStories['• 4.8/5 rating (60K+ reviews)'],
            t.customerStories['• Sub-30 second response time'],
            t.customerStories['• Email and chat covered'],
          ],
        }}
      >
        <p>{t.customerStories['trunkrs_intro']}</p>

        <h2>{t.customerStories['trunkrs_scale_title']}</h2>
        <p>{t.customerStories['trunkrs_scale_p1']}</p>
        <p>{t.customerStories['trunkrs_scale_p2']}</p>
        <p>{t.customerStories['trunkrs_scale_p3']}</p>

        <h2>{t.customerStories['trunkrs_solution_title']}</h2>
        <p>{t.customerStories['trunkrs_solution_p1']}</p>
        <p>{t.customerStories['trunkrs_solution_p2']}</p>
        <p>{t.customerStories['trunkrs_solution_p3']}</p>
        <p>{t.customerStories['trunkrs_solution_p4']}</p>

        <CaseStudyQuote
          quote={[
            t.customerStories['trunkrs_quote_p1'],
            t.customerStories['trunkrs_quote_p2'],
            t.customerStories['trunkrs_quote_p3'],
          ]}
          attribution={t.customerStories['trunkrs_quote_attribution']}
        />

        <h3>{t.customerStories['The Results']}</h3>
        <p>{t.customerStories['trunkrs_results_intro']}</p>

        <CaseStudyResultsTable
          metricLabel={t.customerStories['Metric']}
          impactLabel={t.customerStories['Impact']}
          rows={[
            {
              metric: t.customerStories['Automation rate'],
              impact: isRTL ? '٨٠٪' : '80%',
            },
            {
              metric: t.customerStories['Google rating'],
              impact: isRTL ? '٤,٨/٥ (+٦٠ ألف تقييم)' : '4.8/5 (60K+ reviews)',
            },
            {
              metric: t.customerStories['Response time'],
              impact: t.customerStories['Under 30 seconds'],
            },
            {
              metric: t.customerStories['Channels covered'],
              impact: t.customerStories['Email and chat'],
            },
          ]}
        />

        <p>{t.customerStories['trunkrs_results_p1']}</p>

        <h2>{t.customerStories['trunkrs_impact_title']}</h2>
        <p>{t.customerStories['trunkrs_impact_p1']}</p>
        <p>{t.customerStories['trunkrs_impact_p2']}</p>
      </CaseStudyBody>

      <CustomerVideos />

      <Testimonials />
    </>
  );
};

export default TrunkrsCaseStudy;
